import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchoolListData } from "../service/api";
import {
  setSchoolList,
  setLoader,
  setExpirationTime,
} from "@/redux/dataSlice";
import LoadingSpinner from "@/components/LoadingSpinner";

const useSchoolList = async () => {
  const dispatch = useDispatch();
  const { loader,expirationTime ,schoolList } = useSelector(
    (state: any) => state.data
  );
  

  const fetchDataAsync = async () => {
    dispatch(setLoader(true));
    try {
      const response = await fetchSchoolListData();

      const data = response?.data?.schoolList;

      if (!data) {
        dispatch(setLoader(true));
        dispatch(setSchoolList(null));
      } else {
        dispatch(setSchoolList(data));
        dispatch(setExpirationTime());
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    if (!schoolList || Date.now() > expirationTime) {
      fetchDataAsync();
    }
  }, [schoolList,expirationTime, dispatch]);

  return loader ? <LoadingSpinner/> : null;

};

export default useSchoolList;
